var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCardIcon = function SvgCardIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#040721"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.7727C7 21.3634 7.23705 21.93 7.65901 22.3476C8.08097 22.7653 8.65326 23 9.25 23H22.75C23.3467 23 23.919 22.7653 24.341 22.3476C24.7629 21.93 25 21.3634 25 20.7727V14.6477H7V20.7727ZM9.65179 17.75C9.65179 17.4335 9.77878 17.1301 10.0048 16.9063C10.2309 16.6825 10.5375 16.5568 10.8571 16.5568H12.7857C13.1054 16.5568 13.412 16.6825 13.638 16.9063C13.8641 17.1301 13.9911 17.4335 13.9911 17.75V18.5455C13.9911 18.8619 13.8641 19.1654 13.638 19.3892C13.412 19.6129 13.1054 19.7386 12.7857 19.7386H10.8571C10.5375 19.7386 10.2309 19.6129 10.0048 19.3892C9.77878 19.1654 9.65179 18.8619 9.65179 18.5455V17.75ZM22.75 9H9.25C8.65326 9 8.08097 9.23466 7.65901 9.65235C7.23705 10.07 7 10.6366 7 11.2273V12.2614H25V11.2273C25 10.6366 24.7629 10.07 24.341 9.65235C23.919 9.23466 23.3467 9 22.75 9Z",
    fill: "#F9DA87"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card_icon.dd76c005d1231e3f046fc34d899e3229.svg";